import { db, store } from "../..";
import { dateToTut } from "../../util";
import { tutToDate } from "../../util/dateUtil";
import { Observation } from "../model/observation";
import {
  addObservationAction,
  cleanupObservationAction,
} from "../organisationReducer";

export const listenForObservations = (organisationId: string) => {
  setInterval(() => store.dispatch(cleanupObservationAction()), 1000);

  return db
    .doc("admin")
    .collection("potentialIncidents")
    .where("organisationId", "==", organisationId)
    .where("tut",">",dateToTut() - (1000000*60*60))
    .where("tut","<",dateToTut() + (1000000*60*60*24))
    .onSnapshot((snapshot) => {
      snapshot.docChanges().forEach((change: any) => {
        if (change.type === "added") {
          const data = change.doc.data();
          const observation = {
            deviceId: data.deviceId,
            timeInMillis: tutToDate(data.tut).getTime(),
          } as Observation;
          if (observation.timeInMillis > Date.now() - 60000) {
            store.dispatch(addObservationAction(observation));
          }
        }
      });
    });
};
